@if(address) {
<div class="m-t-1 m-b-3">
    @if (title) {
    <h5 class="fw-bold m-b-1"
        sizeClass="S:p2, !S:p1">
        <span>{{title | translate}}</span>:
    </h5>
    }

    <div class="p1 m-t-1"
         [ngClass]="[title && !client.isS ? 'p1' : 'p2', color ? color : 'col-11']">
        @if (address.firstname || address.lastname) {
        <p class="m-b-1"
           cy-addressStreet>
            {{address.firstname}} {{address.lastname}}
        </p>
        }
        @if (address.street_1) {
        <p class="m-b-1"
           cy-addressStreet>
            {{address.street_1}} {{address.street_2}}
        </p>
        }
        @if (!zipCodeBelow && (address.postcode || address.city)) {
        <p class="m-b-1"
           cy-addressPostcode>
            {{address.postcode}} {{address.city}}
        </p>
        }
        @if (zipCodeBelow && address.city) {
        <p class="m-b-1"
           cy-addressPostcode>
            {{address.city}}
        </p>
        }
        @if (zipCodeBelow && address.postcode ) {
        <p class="m-b-1"
           cy-addressPostcode>
            {{address.postcode}}
        </p>
        }
        @if (address.region) {
        <p class="m-b-1"
           cy-addressRegion>
            {{address.region}}
        </p>
        }
        @if (address.country) {
        <p class="m-b-1"
           cy-addressCountry>
            {{address.country}}
        </p>
        }
    </div>
</div>
}